
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// TODO: implementation (?)

/**
* Rounds a single-precision floating-point number toward positive infinity.
*
* @param {number} x - input value
* @returns {number} rounded value
*
* @example
* var v = ceilf( -4.2 );
* // returns -4.0
*
* @example
* var v = ceilf( 9.99999 );
* // returns 10.0
*
* @example
* var v = ceilf( 0.0 );
* // returns 0.0
*
* @example
* var v = ceilf( NaN );
* // returns NaN
*/
var ceilf = Math.ceil; // eslint-disable-line stdlib/no-builtin-math


// EXPORTS //
export default ceilf;
